// extracted by mini-css-extract-plugin
module.exports = {"tableVisualization":"_1BBRhJsLzgNX0u2cICL5Ro"};